const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    roundId: "",
    projectId: "",
    isConfigurationSet: true
}

export const newProjectRFPDetailsSlice = createSlice({
    name: "newProject-RFP-Details",
    initialState,
    reducers: {
        setNewProjectRFPDetail: (state, actions) => {
            state.projectId = actions.payload.projectId;
            state.roundId = actions.payload.roundId;
        },
        isConfigurationSet: (state, actions) => {
            state.isConfigurationSet = actions.payload
        }

    }

})

export const { setNewProjectRFPDetail, isConfigurationSet } = newProjectRFPDetailsSlice.actions;
export default newProjectRFPDetailsSlice.reducer;
